<div class="wrapper">
  <div id="bqChart" [ngClass]="{'special': (showPlaceholder$ | async)}" #bqChart></div>
  @if ((showPlaceholder$ | async)) {
    <div class="placeholder">
      <p>BQ graph</p>
      <mat-progress-spinner mode="indeterminate" [diameter]="30"></mat-progress-spinner>
    </div>
  }
</div>